import _ from 'underscore';

class DiscussionLearner {
  declare fullName: string;

  declare photoUrl: string;

  declare userId: number;

  constructor(data: any) {
    // TODO: Explicitly assign property values to be type safe.
    Object.assign(this, _(data).pick('fullName', 'photoUrl', 'userId'));
  }
}

export default DiscussionLearner;
